import React from 'react';
import { Box, Typography } from '@mui/material';
import Carousel from './Carousel';

const NewsletterArchives = ({ newsletterArchivesData }) => (
    <Box sx={{ mx: { xs: 2, sm: 4, md: 6, lg: 8 }, mt: 10, mb: 5 }}>
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'left', ml: { xs: 2, sm: 4 } }}>
            BEADS NEWSLETTER ARCHIVES
        </Typography>
        <Carousel content={newsletterArchivesData} slidesPerView={4} spaceBetween={10} isNewsletterArchive={true} />
    </Box>
);

export default NewsletterArchives;
